
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.96 24.491"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.884 11.646l12.8 2.76a.153.153 0 01.029.29l-3.309 1.453 6.051 4.481-2.49 3.362-6.018-4.456-.354 3.593a.153.153 0 01-.285.062L8.714 11.873a.153.153 0 01.17-.227z"}}),_c('path',{attrs:{"d":"M22.83 11.665V3.644A3.154 3.154 0 0019.686.499H3.644A3.154 3.154 0 00.5 3.644v16.041a3.153 3.153 0 003.144 3.144h8.968","stroke-dasharray":"5"}})])])
          )
        }
      }
    